// *Window height
const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};

window.addEventListener('resize', appHeight);
appHeight();

// *Search
const searchWrapp = document.getElementById('js_search_form');
const searchOpen = document.getElementById('js_search_open_btn');
const searchClose = document.getElementById('js_search_close_btn');
const searchInput = document.getElementById('js_search_input');

searchOpen.addEventListener('click', () => {
  searchWrapp.classList.remove('hidden');
  searchWrapp.classList.add('grid');
  searchInput.focus();
})

searchClose.addEventListener('click', () => {
  searchWrapp.classList.remove('grid');
  searchWrapp.classList.add('hidden');
  searchInput.blur();
})

document.addEventListener('keydown', function (event) {
  if (searchWrapp.classList.contains('grid')) {
    const key = event.key;
    if (key === "Escape") {
      searchWrapp.classList.remove('grid');
      searchWrapp.classList.add('hidden');
    }
  }
});

// *Header Desktop scroll
const headerDesk = document.getElementById("js_header_desk");
const headerTop = document.getElementById("js_header_top");
const headerBottom = document.getElementById("js_header_bottom");

if (headerDesk) {
  const headerBottomHeight = headerBottom.offsetHeight;
  let headerTopHeight = headerTop.offsetHeight;
  var prevScrollpos = document.documentElement.scrollTop;
  window.onscroll = function () {
    var currentScrollPos = document.documentElement.scrollTop;
    if (prevScrollpos > currentScrollPos) {
      headerDesk.style.top = "0";
      if (selectSticky) {
        selectSticky.style.top = `${headerTopHeight + 40}px`;
      }
    } else {
      headerDesk.style.top = `-${headerTopHeight}px`;
      if (selectSticky) {
        selectSticky.style.top = `${headerBottomHeight}px`;
      }
    }
    prevScrollpos = currentScrollPos;
  }
}

// *Header Mobile scroll
const headerMob = document.getElementById("js_header_mob");
const selectSticky = document.getElementById("js_select_sticky");

if (headerMob) {
  // Get the height of the headerMob element
  const headerMobHeight = headerMob.offsetHeight;

  // Initialize the last scroll position
  let lastScrollPosition = window.pageYOffset;

  // Add an event listener for the scroll event
  window.addEventListener('scroll', () => {
    // Get the current scroll position
    const currentScrollPosition = window.pageYOffset;

    // Determine the scroll direction
    if (currentScrollPosition > lastScrollPosition) {
      // Scrolling down
      headerMob.style.top = `-${headerMobHeight}px`;
      if (selectSticky) {
        selectSticky.style.top = "0";
      }
    } else {
      // Scrolling up
      headerMob.style.top = "0";
      if (selectSticky) {
        selectSticky.style.top = `${headerMobHeight}px`;
      }
    }

    // Update the last scroll position
    lastScrollPosition = currentScrollPosition;
  });
}

// *Open Side Cart
const sidecartButton = document.getElementById('js_open_side_cart');
const closeSidecartButtons = document.querySelectorAll('.js_close_side_cart');
const sideCart = document.getElementById('js_side_cart');

// Show the side cart
function showSideCart() {
  sideCart.classList.add('grid');
  sideCart.classList.remove('hidden');
  // document.body.classList.add('no_scroll');
}

// Hide the side cart
function hideSideCart() {
  sideCart.classList.remove('grid');
  sideCart.classList.add('hidden');
  // document.body.classList.remove('no_scroll');
}

sidecartButton.addEventListener('click', function () {
  showSideCart();
});

closeSidecartButtons.forEach(button => {
  button.addEventListener('click', function () {
    hideSideCart();
  });
});

// Listen for the ESC key press
document.addEventListener('keydown', function (event) {
  if (sideCart.classList.contains('grid')) {
    if (event.key === 'Escape') {
      hideSideCart();
    }
  };
});

const Cookies = require('js-cookie');

// # BODY ELEMENT
const bodyElement = document.body;

// *Popup Unlogged
const popPrivUnlogClose = document.querySelectorAll('.pop_priv_unlog-close');
const popPrivUnlog = document.getElementById('pop_priv_unlog');

if (popPrivUnlog) {
  document.addEventListener('DOMContentLoaded', function () {
    let cookie = Cookies.get('unlogged_cookie');
    if (!cookie) {
      showPopPrivUnlog();
    }
  });

  // Show Unlogged pop up
  function showPopPrivUnlog() {
    popPrivUnlog.classList.add('grid');
    bodyElement.classList.add('no_scroll');
    popPrivUnlog.classList.remove('hidden');
  }

  // Hide Unlogged pop up
  function hidePopPrivUnlog() {
    popPrivUnlog.classList.remove('grid');
    bodyElement.classList.remove('no_scroll');
    popPrivUnlog.classList.add('hidden');
  }

  popPrivUnlogClose.forEach(button => {
    button.addEventListener('click', function () {
      hidePopPrivUnlog();
      // expires 1 day
      Cookies.set('unlogged_cookie', 'cookie', { expires: 1 })
    });
  });

  // Listen for the ESC key press
  document.addEventListener('keydown', function (event) {
    if (popPrivUnlog.classList.contains('grid')) {
      if (event.key === 'Escape') {
        hidePopPrivUnlog();
        Cookies.set('unlogged_cookie', 'cookie', { expires: 1 })
      }
    };
  });
}

// *Popup Logged
const popPrivLoggedClose = document.querySelectorAll('.pop_priv_logged-close');
const popPrivLogged = document.getElementById('pop_priv_logged');

if (popPrivLogged) {
  document.addEventListener('DOMContentLoaded', function () {
    let cookie = Cookies.get('logged_cookie');
    if (!cookie) {
      showPopPrivLogged();
    }
  });

  // Show Logged pop up
  function showPopPrivLogged() {
    popPrivLogged.classList.add('grid');
    bodyElement.classList.add('no_scroll');
    popPrivLogged.classList.remove('hidden');
  }

  // Hide Logged pop up
  function hidePopPrivLogged() {
    popPrivLogged.classList.remove('grid');
    bodyElement.classList.remove('no_scroll');
    popPrivLogged.classList.add('hidden');
  }

  popPrivLoggedClose.forEach(button => {
    button.addEventListener('click', function () {
      hidePopPrivLogged();
      // expires 1 day
      Cookies.set('logged_cookie', 'cookie', { expires: 1 })
    });
  });

  // Listen for the ESC key press
  document.addEventListener('keydown', function (event) {
    if (popPrivLogged.classList.contains('grid')) {
      if (event.key === 'Escape') {
        hidePopPrivLogged();
        Cookies.set('logged_cookie', 'cookie', { expires: 1 })
      }
    };
  });
}

// *Cookie consent
const cookieConsent = document.getElementById('js_cookie_consent');
const cookieConsentAccept = document.getElementById('js_cookie_consent_accept');

document.addEventListener('DOMContentLoaded', function () {
  let cookieConsent = Cookies.get('consent_cookie');
  if (!cookieConsent) {
    setTimeout(showCookieConsent, 1000);
  }
});

// Shnow cookie consent
function showCookieConsent() {
  cookieConsent.classList.add('translate-y-0');
  cookieConsent.classList.remove('translate-y-full');
}

// *Hide cookie consent
function hideCookieConsent() {
  cookieConsent.classList.add('translate-y-full');
  cookieConsent.classList.remove('translate-y-0');
}

cookieConsentAccept.addEventListener('click', function () {
  hideCookieConsent();
  // expires 1 day
  Cookies.set('consent_cookie', 'cookie', { expires: 1 })
})


// *MENU MOBILE
const openMenu = document.getElementById('js_open_menu');
const closeMenu = document.querySelectorAll('.js_close_menu');
const menuElement = document.getElementById('js_menu_element');

//@@menu - submenu man & woman
const menuMen = document.querySelector(".js_menu_men");
const submenuMen = document.querySelector(".js_submenu_men");
const menClothes = document.querySelector(".js_men_clothes");
const submenuMenClothes = document.querySelector(".js_men_clothes_submenu");
const menShoes = document.querySelector(".js_men_shoes");
const submenuManShoes = document.querySelector(".js_men_shoes_submenu");
const menAccessory = document.querySelector(".js_men_accessory");
const submenuManAccessory = document.querySelector(".js_men_accessory_submenu");
const menuWomen = document.querySelector(".js_menu_women");
const submenuWomen = document.querySelector(".js_submenu_women");
const womenClothes = document.querySelector(".js_women_clothes");
const submenuWomenClothes = document.querySelector(".js_women_clothes_submenu");
const womenShoes = document.querySelector(".js_women_shoes");
const submenuWomanShoes = document.querySelector(".js_women_shoes_submenu");
const womenAccessory = document.querySelector(".js_women_accessory");
const submenuWomanAccessory = document.querySelector(".js_women_accessory_submenu");
const menuBrands = document.querySelector(".js_menu_brands");
const submenuBrands = document.querySelector(".js_submenu_brands");

function showMenu() {
  menuElement.classList.add('grid');
  menuElement.classList.remove('hidden');
  menuElement.classList.add('hidden_menu');

  // document.body.classList.add('no_scroll');
}

function hideMenu() {
  menuElement.classList.remove('grid');
  menuElement.classList.add('hidden');
  menuElement.classList.remove('hidden_menu');

  // document.body.classList.remove('no_scroll');
  // close all open menus and submenus
  menuMen.classList.remove('rotate');
  submenuMen.classList.remove('active');
  menClothes.classList.remove('rotate');
  submenuMenClothes.classList.remove('active');
  menShoes.classList.remove('rotate');
  submenuManShoes.classList.remove('active');
  menAccessory.classList.remove('rotate');
  submenuManAccessory.classList.remove('active');
  menuWomen.classList.remove('rotate');
  submenuWomen.classList.remove('active');
  womenClothes.classList.remove('rotate');
  submenuWomenClothes.classList.remove('active');
  womenShoes.classList.remove('rotate');
  submenuWomanShoes.classList.remove('active');
  womenAccessory.classList.remove('rotate');
  submenuWomanAccessory.classList.remove('active');
  menuBrands.classList.remove('rotate');
  submenuBrands.classList.remove('active');
}

if (menuElement) {
  openMenu.addEventListener('click', function () {
    showMenu();
  });

  closeMenu.forEach(button => {
    button.addEventListener('click', function () {
      hideMenu();
    });
  });

  // *sidemenu
  // $man
  menuMen.addEventListener('click', function () {
    menuMen.classList.toggle('rotate');
    submenuMen.classList.toggle('active');
  });

  menClothes.addEventListener('click', function () {
    menClothes.classList.toggle('rotate');
    submenuMenClothes.classList.toggle('active');
  });

  menShoes.addEventListener('click', function () {
    menShoes.classList.toggle('rotate');
    submenuManShoes.classList.toggle('active');
  });

  menAccessory.addEventListener('click', function () {
    menAccessory.classList.toggle('rotate');
    submenuManAccessory.classList.toggle('active');
  });

  // $woman
  menuWomen.addEventListener('click', function () {
    menuWomen.classList.toggle('rotate');
    submenuWomen.classList.toggle('active');
  });

  womenClothes.addEventListener('click', function () {
    womenClothes.classList.toggle('rotate');
    submenuWomenClothes.classList.toggle('active');
  });

  womenShoes.addEventListener('click', function () {
    womenShoes.classList.toggle('rotate');
    submenuWomanShoes.classList.toggle('active');
  });

  womenAccessory.addEventListener('click', function () {
    womenAccessory.classList.toggle('rotate');
    submenuWomanAccessory.classList.toggle('active');
  });

  // $brands
  menuBrands.addEventListener('click', function () {
    menuBrands.classList.toggle('rotate');
    submenuBrands.classList.toggle('active');
  });
}

//* Toggle Mobile menu profile links
const toggleProfileLinksButton = document.getElementById("profile_menu_links_btn");
const profileLinksData = document.getElementById("profile_menu_links");

if (toggleProfileLinksButton) {
  toggleProfileLinksButton.addEventListener("click", function (e) {
    // Toggle max-height animation and margin bottom
    profileLinksData.classList.toggle('max-h-0');
    profileLinksData.classList.toggle('mb-0');

    profileLinksData.classList.toggle('max-h-[400px]');
    profileLinksData.classList.toggle('mb-s30');
  });
}

// *Sizes product
// Get all elements with the class "js_get_selected_size"
const sizeElements = document.querySelectorAll('.js_get_selected_size');

if (sizeElements) {
  // Add event listener to each element
  sizeElements.forEach(element => {
    element.addEventListener('click', () => {
      // Add classes to the clicked element
      element.classList.add('bg-black', 'text-white');

      // Remove classes from other elements
      sizeElements.forEach(otherElement => {
        if (otherElement !== element) {
          otherElement.classList.remove('bg-black', 'text-white');
        }
      });
    });
  });
}

//* Newsletter validation
// import JustValidate from 'just-validate';

// const footerNewsletterForm = document.getElementById('footer_newsletter_form');
// const popNewsletterForm = document.getElementById('pop_newsletter_form');

// window.onload = function () {
//   if (footerNewsletterForm) {
//     const footerNewsletterFormValidator = new JustValidate('#footer_newsletter_form');

//     footerNewsletterFormValidator
//       .addField('#footer_news_email', [
//         {
//           rule: 'required',
//           errorMessage: 'E-mail je obavezan',
//         },
//         {
//           rule: 'email',
//           errorMessage: 'Email adresa koju ste uneli je nevažeća.',
//         },
//       ])
//       .addField('#footer_news_agree', [
//         {
//           rule: 'required',
//           errorMessage: "Prihvatanje uslova je obavezno.",
//         },
//       ],
//         {
//           errorsContainer: '#terms-error',
//         }
//       ).onSuccess((() => {
//         footerNewsletterForm.submit()
//       }))
//   }
//   if (popNewsletterForm) {
//     const popNewsletterFormValidator = new JustValidate('#pop_newsletter_form');

//     popNewsletterFormValidator
//       .addField('#pop_news_email', [
//         {
//           rule: 'required',
//           errorMessage: 'E-mail je obavezan',
//         },
//         {
//           rule: 'email',
//           errorMessage: 'Email adresa koju ste uneli je nevažeća.',
//         },
//       ])
//       .addField('#pop_news_agree', [
//         {
//           rule: 'required',
//           errorMessage: "Prihvatanje uslova je obavezno.",
//         },
//       ],
//         {
//           errorsContainer: '#terms-error',
//         }
//       ).onSuccess((() => {
//         popNewsletterForm.submit()
//       }))
//   }
// };

// * Back on previous page remove open classes
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    searchWrapp.classList.add('hidden');
    searchWrapp.classList.remove('grid');
    if (menuElement) {
      hideMenu();
    }
  }
});

// * Privilege badge
const privilegeBadgePopup = document.getElementById('privilege-badge_popup');

const privilegeBadgeX = document.getElementById('privilege-badge_x');
const privilegeBadgeM = document.getElementById('privilege-badge_m');

const privilegeBadgeClose = document.querySelectorAll('.privilege-badge_popup_close_btn');

// # Open-Close Privilege badge Popup
// # Open popup
if (privilegeBadgeM && privilegeBadgePopup && privilegeBadgeX) {
  let privilegeBadgeRequestLocked = false;

  privilegeBadgeM.addEventListener('click', () => {
    // Always start popup at the top
    privilegeBadgePopup.scrollTop = 0;

    privilegeBadgePopup.classList.remove('invisible', 'opacity-0');
    privilegeBadgePopup.classList.add('visible', 'opacity-1');

    privilegeBadgeM.classList.remove('visible', 'opacity-1');
    privilegeBadgeM.classList.add('invisible', 'opacity-0');

    privilegeBadgeX.classList.remove('invisible', 'opacity-0');
    privilegeBadgeX.classList.add('visible', 'opacity-1');

    const privilegeBadgeLogged = document.getElementById('privilege-badge_parent_logged');
    const requestUrl = privilegeBadgeLogged?.dataset.requestUrl;

    if (!requestUrl || privilegeBadgeRequestLocked) {
      return;
    }

    privilegeBadgeRequestLocked = true;
    setTimeout(() => {
      privilegeBadgeRequestLocked = false;
    }, 10000);

    axios
        .get(requestUrl)
        .then((response) => {
          
            if (response.data.points && response.data.points > 0) {
                // Update whatever displays the points
                document.querySelector("#user-points").textContent =
                    response.data.points;
            }
        
        })
        .catch((error) => {
            console.error(error);
        });
  });
}



// # Benefits & Loyalty Open/Close
const privilegeBadgeParentLogged = document.getElementById('privilege-badge_parent_logged');
const privilegeBadgeParentBenefits = document.getElementById('privilege-badge_benefits');
const privilegeBadgeParentBenefitsOpen = document.getElementById('privilege-badge_benefits_open');
const privilegeBadgeParentLoyalty = document.getElementById('privilege-badge_loyalty');
const privilegeBadgeParentLoyaltyOpen = document.getElementById('privilege-badge_loyalty_open');
const benefitsDlcClose = document.querySelectorAll('.benefits_dlc_close');


// # Open Benefits / Loyalty section
const openPrivilegeBadgeSection = (section) => {
  if (!section) return;

  // Reset popup scroll position
  if (privilegeBadgePopup) {
    privilegeBadgePopup.scrollTop = 0;
  }

  section.classList.remove('hidden');
  section.classList.add('animate-lvlappear');
};


// # Close Benefits / Loyalty section
const closePrivilegeBadgeSection = (section) => {
  if (!section) return;

  section.classList.add('hidden');
  section.classList.remove('animate-lvlappear');
};


// # Open Benefits
if (privilegeBadgeParentBenefitsOpen && privilegeBadgeParentBenefits) {
  privilegeBadgeParentBenefitsOpen.addEventListener('click', () => {

    closePrivilegeBadgeSection(privilegeBadgeParentLogged);

    openPrivilegeBadgeSection(privilegeBadgeParentBenefits);
  });
}


// # Open Loyalty
if (privilegeBadgeParentLoyaltyOpen && privilegeBadgeParentLoyalty) {
  privilegeBadgeParentLoyaltyOpen.addEventListener('click', () => {

    closePrivilegeBadgeSection(privilegeBadgeParentLogged);

    openPrivilegeBadgeSection(privilegeBadgeParentLoyalty);
  });
}


// # Close Benefits / Loyalty
benefitsDlcClose.forEach((closeButton) => {
  closeButton.addEventListener('click', () => {

    closePrivilegeBadgeSection(privilegeBadgeParentBenefits);

    closePrivilegeBadgeSection(privilegeBadgeParentLoyalty);

    openPrivilegeBadgeSection(privilegeBadgeParentLogged);
  });
});



// # LVLS for unlogged users
const privilegeBadgeParentLvls = document.getElementById(
  'privilege-badge_parent_lvls'
);

const privilegeBadgeLvlClose = document.querySelectorAll('.lvl_close');

const privilegeBadgeLevels = [
  {
    title: document.getElementById('entry-lvl-title'),
    level: document.getElementById('entry-lvl'),
  },
  {
    title: document.getElementById('silver-lvl-title'),
    level: document.getElementById('silver-lvl'),
  },
  {
    title: document.getElementById('gold-lvl-title'),
    level: document.getElementById('gold-lvl'),
  },
  {
    title: document.getElementById('black-lvl-title'),
    level: document.getElementById('black-lvl'),
  },
  {
    title: document.getElementById('platinum-lvl-title'),
    level: document.getElementById('platinum-lvl'),
  },
];




// # Reset Privilege badge content to initial state
const resetPrivilegeBadgeContent = () => {
  // Hide Benefits / Loyalty
  closePrivilegeBadgeSection(privilegeBadgeParentBenefits);
  closePrivilegeBadgeSection(privilegeBadgeParentLoyalty);

  // Hide all individual levels
  privilegeBadgeLevels.forEach(({ level }) => {
    if (level) {
      level.classList.add('hidden');
      level.classList.remove('animate-lvlappear');
    }
  });

  // Show the correct main content
  // Backend determines which one exists
  if (privilegeBadgeParentLvls) {
    privilegeBadgeParentLvls.classList.remove('hidden');
    privilegeBadgeParentLvls.classList.add('animate-lvlappear');
  } else if (privilegeBadgeParentLogged) {
    privilegeBadgeParentLogged.classList.remove('hidden');
    privilegeBadgeParentLogged.classList.add('animate-lvlappear');
  }
};



// # Close popup function
const closePrivilegeBadgePopup = () => {
  // Reset internal popup content
  resetPrivilegeBadgeContent();

  // Close whole popup
  if (privilegeBadgePopup) {
    privilegeBadgePopup.classList.remove('visible', 'opacity-1');
    privilegeBadgePopup.classList.add('invisible', 'opacity-0');
  }

  if (privilegeBadgeX) {
    privilegeBadgeX.classList.remove('visible', 'opacity-1');
    privilegeBadgeX.classList.add('invisible', 'opacity-0');
  }

  if (privilegeBadgeM) {
    privilegeBadgeM.classList.remove('invisible', 'opacity-0');
    privilegeBadgeM.classList.add('visible', 'opacity-1');
  }
};



// # Close using X
if (privilegeBadgeX) {
  privilegeBadgeX.addEventListener('click', closePrivilegeBadgePopup);
}


// # Close using any .privilege-badge_popup_close_btn
privilegeBadgeClose.forEach((button) => {
  button.addEventListener('click', closePrivilegeBadgePopup);
});



// # Open selected level
privilegeBadgeLevels.forEach(({ title, level }) => {
  if (title && level) {
    title.addEventListener('click', () => {

      // Reset popup scroll position
      if (privilegeBadgePopup) {
        privilegeBadgePopup.scrollTop = 0;
      }

      // Hide parent levels
      if (privilegeBadgeParentLvls) {
        privilegeBadgeParentLvls.classList.add('hidden');
        privilegeBadgeParentLvls.classList.remove('animate-lvlappear');
      }
      if (privilegeBadgeParentLogged) {
        privilegeBadgeParentLogged.classList.add('hidden');
        privilegeBadgeParentLogged.classList.remove('animate-lvlappear');
      }

      // Show selected level
      level.classList.remove('hidden');
      level.classList.add('animate-lvlappear');
    });
  }
});


// # Close selected level
privilegeBadgeLvlClose.forEach((closeButton) => {
  closeButton.addEventListener('click', () => {
    // Hide all levels
    privilegeBadgeLevels.forEach(({ level }) => {
      if (level) {
        level.classList.add('hidden');
        level.classList.remove('animate-lvlappear');
      }
    });

    // Show parent levels
    if (privilegeBadgeParentLvls) {
      privilegeBadgeParentLvls.classList.remove('hidden');
      privilegeBadgeParentLvls.classList.add('animate-lvlappear');
    }
    if (privilegeBadgeParentLogged) {
      privilegeBadgeParentLogged.classList.remove('hidden');
      privilegeBadgeParentLogged.classList.add('animate-lvlappear');
    }
  });
});


// # Sticky element styles on scroll

if (privilegeBadgePopup) {
  const privilegeBadgeBgElements =
    privilegeBadgePopup.querySelectorAll('.privilege-badge_bg');

  const privilegeBadgeOpacityElements =
    privilegeBadgePopup.querySelectorAll('.privilege-badge_opacity');

  privilegeBadgePopup.addEventListener('scroll', () => {
    const isScrolled = privilegeBadgePopup.scrollTop > 0;

    privilegeBadgeBgElements.forEach((el) => {
      el.classList.toggle('bg-black', isScrolled);
    });

    privilegeBadgeOpacityElements.forEach((el) => {
      el.classList.toggle('opacity-0', !isScrolled);
    });
  });
}
